import { atom } from 'jotai';

export const receiptAmountAtom = atom<string>('');
export const receiptCardBrand = atom<string>('');
export const receiptcardLastFour = atom<string>('');
export const receiptemail = atom<string>('');
export const receiptPaymentDate = atom<string>('');
export const receiptTransactionNumber = atom<string>('');